import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { a as c } from "../../../index-CROKJrb5.js";
import { Typography as e } from "../../Typography/index.js";
import { c as m } from "../../../create-component-CBAeEoQ6.js";
const p = m("FormControlHighlight", ({ children: r, className: t, ...o }) => /* @__PURE__ */ a.jsx(
  e,
  {
    size: "meta",
    className: c(
      "cur-order-last cur-w-full cur-bg-surface-brand-light cur-px-3 cur-py-2 cur-text-meta cur-text-surface-secondary cur-transition-all",
      t
    ),
    ...o,
    children: r
  }
));
export {
  p as FormControlHighlight
};
//# sourceMappingURL=index.js.map
